import * as api from '../../api'
import { toJS } from 'mobx'
export default async horde => {
  const entities = horde.entities || []
  const checkResult = {
    warnings: [],
    errors: [],
    nb: 0
  }

  const xp = await api.experiences.get(horde.experienceId)
  const xpLink = '/site/' + xp.siteId + '/experience/' + xp._id
  if (!horde.maxScore) {
    checkResult.warnings.push({
      text: `La horde ${horde.name} n'a pas de score.`,
      link: xpLink + '/track/' + horde._id,
      _id: horde._id
    })
  }
  checkResult.nb++
  if (horde.timeLimit) {
    if (!horde.failure) {
      checkResult.errors.push({
        text: `La horde ${horde.name} a un chrono, mais aucun scénario n'est lancé lorsque le temps est écoulé.`,
        link: xpLink + '/track/' + horde._id,
        _id: horde._id
      })
    }
  }
  checkResult.nb++
  if (entities.length === 0) {
    checkResult.errors.push({
      text: `La horde ${horde.name} n'a pas de poursuivant (entité).`,
      link: xpLink + '/track/' + horde._id,
      _id: horde._id
    })
  }

  checkResult.nb++

  entities.forEach((entity, index) => {
    if (!entity.marker || !entity.marker.resource) {
      checkResult.warnings.push({
        text: `L'entité ${index + 1} de la horde ${horde.name} n'a pas d'icône.`,
        link: xpLink + '/track/' + horde._id + '/hordeentity/' + entity._id,
        _id: horde._id
      })
    }
    checkResult.nb++
    if (!entity.location || entity.location.length !== 2) {
      checkResult.warnings.push({
        text: `L'entité ${index + 1} de la horde ${horde.name} n'a pas de position.`,
        link: xpLink + '/track/' + horde._id + '/hordeentity/' + entity._id,
        _id: horde._id
      })
    }
    checkResult.nb++
  })

  const objectives = toJS(await api.points.getFrom('tracks', horde._id)) || []

  for (let counter = 0; counter < objectives.length; counter++) {
    const objective = objectives[counter]
    checkResult.nb++
    if (!objective.scenario) {
      checkResult.warnings.push({
        text: `L'objectif ${objective.name} de la horde ${horde.name} n'a pas de scénario de fin.`,
        link: xpLink + '/track/' + horde._id,
        _id: horde._id
      })
    } else {
      const scenario = api.scenarios.get(objective.scenario)
      checkResult.nb++
      if (!scenario) {
        checkResult.warnings.push({
          text: `Le scénario déclenché par l'objectif ${objective.name} de la horde ${horde.name} n'existe pas.`,
          link: xpLink + '/track/' + horde._id,
          _id: horde._id
        })
      } else {
        const modules = await api.modules.getFrom('scenarios', objective.scenario)
        checkResult.nb++
        if (modules.length === 0 && (!scenario.onEnd || !scenario.onEnd.length)) {
          checkResult.errors.push({
            text: `Le scénario déclenché par l'objectif ${objective.name} de la horde ${horde.name} est vide.`,
            link: xpLink + '/track/' + horde._id,
            _id: horde._id
          })
        }
      }
    }
  }

  return checkResult
}
